module.exports = __webpack_public_path__ + "static/media/sad.ff337ea2.svg";